import { useEffect, useMemo, useState } from "react";

import { SearchForm } from "../../types";
import { debounce } from "lodash-es";

interface Props {
  values: SearchForm;
  dirty: boolean;
  submitForm: () => void;
}

export function LocationDebouncedSubmit(props: Props) {
  const { values, submitForm, dirty } = props;
  const [previousValue, setPreviousValue] = useState("");
  const debouncedSubmit = useMemo(
    () =>
      debounce((value: string) => {
        submitForm();
        setPreviousValue(value);
      }, 380),
    [submitForm]
  );

  useEffect(() => {
    if (dirty && previousValue !== values.search) {
      debouncedSubmit.cancel();
      debouncedSubmit(values.search);
    }

    return () => {
      debouncedSubmit.cancel();
    };
  }, [values.search, debouncedSubmit, dirty, previousValue]);

  return null;
}
